import React from 'react';
import TextInput from '../textInput/textInput';
import ApplyChangeButton from '../button/button';
import Tooltip from '../tooltip/tooltip';
var DEFAULT_BUTTON_TEXT = 'Done';
export default function () {
  return /*#__PURE__*/React.createElement("div", {
    className: this.props.getClassName('sbdl-text-edit') + (this.isInvalid() ? ' invalid' : '')
  }, /*#__PURE__*/React.createElement(Tooltip, {
    disabled: !this.isInvalid(),
    key: "invalidMessage",
    isOpen: true,
    content: this.state.invalidMessage,
    shouldTranslate: this.props.shouldTranslateInvalidMessage
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: this.state.value,
    focus: this.props.autoFocus,
    onChange: this.onInputTextChange,
    maxLength: this.props.maxLength,
    placeholder: this.props.placeholder,
    shouldTranslate: false
  })), /*#__PURE__*/React.createElement(ApplyChangeButton, {
    onClick: this.applyChanges,
    disabled: this.isInvalid()
  }, this.props.buttonText || DEFAULT_BUTTON_TEXT));
}